
import {ElLoading} from "element-plus";

const columnList: Array<column> = [
    {
        prop: "code",
        label: "车牌号码",
        width: 66,
    },
    {
        prop: "vin",
        label: "车架号",
        width: 66,
    },
    {
        prop: "model_name",
        label: "品牌车型",
        width: 66,
    },
    {
        prop: "repair_unit_name",
        label: "所属单位",
        width: 66,
    },
    {
        prop: "expiration_time_text",
        label: "保险到期时间",
        width: 66,
    },
    {
        prop: "user_id",
        label: "绑定会员",
        width: 66,
    },
    {
        prop: "last_service_time_text",
        label: "最近服务",
        width: 66,
    },
    // {
    //     prop: "nickname",
    //     label: "接车人",
    //     width: 66,
    // },
    // {
    //     prop: "send_for_repair",
    //     label: "送修人",
    //     width: 66,
    // },
    {
        prop: "master_phone",
        label: "手机",
        width: 66,
    }
];
import {Request} from "@/api/request";
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    addCarInfo, carManageExport, editCarInfoDetail, getCarBrand, getCarInfoDetail, getOrderCarInfo,
    getOrderCarRepairunit, getOrderCarSelectList,
    getPurchaseTable,
    getReceivingCar,
    getSupplierList, getVinInfo,
    partsConstructionExport, postEditReceivingCar
} from "@/api/http";
import {column} from "@/assets/types/common";
import {validateInput} from "@/assets/js/formRules";
import router from "@/router";
import {useRouter} from "vue-router";

export default defineComponent({
    name: "Vehicle",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["车辆管理"]);
        let router = useRouter();
        //修改功能
        let editCarData = reactive({
                dialog_show: false,
                rules: {},
                form: {
                    vin: "",
                    units_id: "",
                    master_name: "",
                    idcard: "",
                    nm_time_text: "",
                    aidue_text: "",
                    ccidue_text: "",
                    cipnumber: "",
                    car_brand_id: "",
                    car_series_id: "",
                    body_color: "",
                    car_master_phone: "",
                    engine_number: "",
                    maintenance_mileage: "",
                    purchase_time_text: "",
                    cicompany_id: "",
                    tips: "",
                    nmtime: "",
                    aidue: "",
                    ccidue: "",
                    purchase_time: "",
                    code:"",
                    jicompany_id:"",
                    dipolicy_no:"",
                    compulsory_insurance_due:"",
                    compulsory_insurance_due_text:""
                },
                formRef: null,
                repairunit_data: [],
                car_brand_data: [],
                insurance_data: [],
                car_series_data: []
            }),
            selectCarBrandChange = (() => {
                getCarBrand({
                    brand_id: Number(editCarData.form.car_brand_id),
                }).then((res: any) => {
                    editCarData.car_series_data = res?.content?.list || [];
                    editCarData.form.car_series_id = "";
                });
            }),
            // 查找车型信息，并自动填写品牌车型
            checkVinInfo = (()=>{
            getVinInfo({vin:editCarData.form.vin}).then((res:any)=>{
                if(res.status == 200){
                    let info = res.content;
                    // 如果是新增品牌车型，则重新渲染车品牌列表和车系列表
                    if(info.is_new == 1){
                        getCarBrand({}).then((res: any) => {
                            editCarData.car_brand_data = res?.content?.list || [];
                            setTimeout(() => {
                                // 选中车品牌
                                editCarData.form.car_brand_id = info.car_brand_id;
                                // 获取对应品牌的车系
                                getCarBrand({
                                    brand_id: Number(info.car_brand_id),
                                }).then((res: any) => {
                                    editCarData.car_series_data = res?.content?.list || [];
                                    // 选中对应车系
                                    editCarData.form.car_series_id = info.car_series_id;
                                });
                            },500)
                        });
                    }else{
                        // 选中车品牌
                        editCarData.form.car_brand_id = info.car_brand_id;
                        // 获取对应品牌的车系
                        getCarBrand({
                            brand_id: Number(info.car_brand_id),
                        }).then((res: any) => {
                            editCarData.car_series_data = res?.content?.list || [];
                            // 选中对应车系
                            editCarData.form.car_series_id = info.car_series_id;
                        });
                    }
                }
            });
        }),
            saveCarInfoChange = (e: any, key: string) => {
                if (key == "nmtime" || key == "aidue" || key == "ccidue" || key == "purchase_time" || key == "compulsory_insurance_due") {
                    if (e) {
                        e = new Date(e).getTime() / 1000;
                        editCarData.form[key] = e;
                    } else {
                        editCarData.form[key] = "";
                    }
                    
                }
            },
            saveSubmit = (() => {
                console.log(editCarData.form);
                if (select_carId.value) {
                    // 修改
                    editCarInfoDetail({car_id: select_carId.value, ...editCarData.form}).then(() => {
                        editCarData.dialog_show = false;
                        getTableData();
                    });
                } else {
                    // 新增
                    addCarInfo(editCarData.form).then(() => {
                        editCarData.dialog_show = false;
                        getTableData();
                    });
                }
            });
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            select_carId = ref(null),
            headClass = inject("headClass"),
            screenParameter = ref({
                repair_unit_id: null,
                page: currentPage.value,
                pagesize: pageSize.value,
                search: "",
                yue: null,
                is_check: 0,
            } as any),
            selectList = ref({
                liveness: [],
                repair: [],
            } as any),
            serviceDateChange = (e: any): void => {
                if (e) {
                    screenParameter.value.latest_service_time_start = e[0].getTime()
                        // ? new Date(e[0]).getTime() / 1000
                        // : null;
                    screenParameter.value.latest_service_time_end = e[1].getTime()
                        // ? new Date(e[1]).getTime() / 1000
                        // : null;
                } else {
                    screenParameter.value.latest_service_time_start = null;
                    screenParameter.value.latest_service_time_end = null;
                }
                getTableData();
            },
            addCarDialog = (): void => {
                select_carId.value = null;
                editCarData.dialog_show = true;
                editCarData.form = {
                    vin: "",
                    units_id: "",
                    master_name: "",
                    idcard: "",
                    nm_time_text: "",
                    aidue_text: "",
                    ccidue_text: "",
                    cipnumber: "",
                    car_brand_id: "",
                    car_series_id: "",
                    body_color: "",
                    car_master_phone: "",
                    engine_number: "",
                    maintenance_mileage: "",
                    purchase_time_text: "",
                    cicompany_id: "",
                    tips: "",
                    nmtime: "",
                    aidue: "",
                    ccidue: "",
                    purchase_time: "",
                    code: "",
                    jicompany_id: "",
                    dipolicy_no: "",
                    compulsory_insurance_due: "",
                    compulsory_insurance_due_text: ""
                };
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                console.log(currentPage.value);
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let data = {...screenParameter.value,page:currentPage.value,pagesize:pageSize.value};
                Request.axiosInstance({
                    url: "adminapi/CustomerService/carManageList",
                    data,
                }).then((res: any) => {
                    selectList.value.repair = res?.content?.repairunit || [];
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0
                });
            },
            columnChange = (item: any, type: number): void => {
                select_carId.value = item.id;
                switch (type) {
                    //服务历史，这辆车的所有订单
                    case 1:
                        router.push({
                            path: "/customer/expire/serviceHistory",
                            query: {
                                car_id: item.id,
                            },
                        });
                        break;
                    case 2:
                        break;
                    case 3://修改
                        editCarData.dialog_show = true;
                        editCarData.form = {
                            vin: "",
                            units_id: "",
                            master_name: "",
                            idcard: "",
                            nm_time_text: "",
                            aidue_text: "",
                            ccidue_text: "",
                            cipnumber: "",
                            car_brand_id: "",
                            car_series_id: "",
                            body_color: "",
                            car_master_phone: "",
                            engine_number: "",
                            maintenance_mileage: "",
                            purchase_time_text: "",
                            cicompany_id: "",
                            tips: "",
                            nmtime: "",
                            aidue: "",
                            ccidue: "",
                            purchase_time: "",
                            code:"",
                            jicompany_id:"",
                            dipolicy_no:"",
                            compulsory_insurance_due:"",
                            compulsory_insurance_due_text:""
                    };
                        
                        // getReceivingCar({order_id: item.id}).then((res: any) => {
                        //     if (res.status == 200) {
                        //         editCarData.form = res.content.order_car;
                        //         // 获取选中的车品牌下的车系
                        //         if (res.content.order_car) {
                        //             getCarBrand({
                        //                 brand_id:
                        //                 res.content.order_car.car_brand_id,
                        //             }).then((res: any) => {
                        //                 editCarData.car_series_data =
                        //                     res?.content?.list || [];
                        //             });
                        //         }
                        //     }
                        // });
                        getCarInfoDetail({car_id:item.id}).then((res:any)=>{
                            editCarData.form = res.content.list;
                        });
                        getCarBrand({brand_id: item.car_brand_id,}).then((res: any) => {
                            editCarData.car_series_data =
                                res?.content?.list || [];
                        });
                        break;
                    case 4:
                        Request.axiosInstance({
                            url: 'adminapi/Order/delCarUser',
                            data: {
                                order_id: item.id,
                                type: 1
                            },
                        }).then((res: any) => {
                            getTableData();
                        });
                        break;
                }
                
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                
                carManageExport(screenParameter.value).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(() => {
                    loading.close();
                });
            },
            selectChange = (e: number): void => {
                // console.log(e);
                getTableData();
            };
        
        onMounted(() => {
            Request.axiosInstance({
                url: "adminapi/car/liveness",
            }).then((res: any) => {
                selectList.value.liveness = res?.content?.list[0] || [];
                // console.log(selectList.value.liveness )
                getTableData();
            });
            getOrderCarRepairunit({}).then((res: any) => {
                editCarData.repairunit_data = res?.content?.list || [];
            });
            getCarBrand({}).then((res: any) => {
                editCarData.car_brand_data = res?.content?.list || [];
            });
            getOrderCarSelectList().then((res: any) => {
                if (res.status == 200) {
                    // select.project_type_data =
                    //     res.content.project_type_data;
                    // select.partner_data = res.content.project_type_data;
                    editCarData.insurance_data = res.content.insurance_data;
                }
            });
        });
        
        return {
            columnList,
            tableData,
            loading,
            columnChange,
            headClass,
            total,
            handleSizeChange,
            handleCurrentChange,
            screen,
            screenParameter,
            currentPage,
            pageSize,
            selectChange,
            selectList,
            exportChange,
            editCarData,
            selectCarBrandChange,
            saveSubmit,
            saveCarInfoChange,
            checkVinInfo,
            serviceDateChange,
            addCarDialog
        };
    },
});
